import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Button, FormGroup, Label, Input, Alert, Modal,
    ModalHeader, ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import { API } from 'aws-amplify';
import '../estilos.css';
import {
    updateRecibaSeriales, updatePProduccion, updateUbicacion, createUbicacion, createRecuperacion, updateRecuperacion, updatePlaneacion,
    createRecibaSerialesMP,
    updateRecibaSerialesMP,
    updateReciba,
    createPlaneacionGeneral,
    createPProduccionGeneral,
    updatePProduccionGeneral,
    updatePlaneacionGeneral,
    updateEmbarque,
    updateEmbarqueSeriales,
    createADatosROperacion
} from '../../graphql/mutations';
import * as IoIcons from 'react-icons/io';
import Moment, { updateLocale } from 'moment';
import QrReader from "react-qr-reader";
import BarcodeReader from 'react-barcode-reader';
import { GetEmbarques, GetEmbarquesSeriales, GetPProduccion, GetPProduccionGeneral, GetPProduccionID, GetPlaneacion, GetPlaneacionGeneral, GetProductosID, GetReciba, GetRecibaSeriales, GetRecibaSerialesID, GetUbicacion, GetUsuarios } from '../queries/Queries';
import { actualizarPPPGeneralM } from '../queries/Mutations';
import { generateClient } from "aws-amplify/api";

const API = generateClient();

const initialfFormState = { formType: 'Producción' }


function Tools() {
    //Declaración de variables                
    const [datosResultado, SetDatosResultado] = useState([]);
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const ppproduccion = window.$ProduccionCalidad ? window.$ProduccionCalidad : false;
    const [cargando, setCargando] = useState(false);

    const [aVisible, setAVisible] = useState(false);

    const onDismiss = () => setAVisible(false);

    Moment.locale('en');
    var now = new Date();


    //Método useEffect
    useEffect(() => {
        //fetchUsuario();
    }, []);

    //Obtiene el nombre de usuario del usuario logueado
    /*async function fetchUsuario() {
        //Filtro por planeación activa        
        let filter = {
            usuario: {
                eq: userName
            }
        }
        //Se obtienen los datos del usuario
        const apiData = await GetUsuarios(filter);
        //Se filtran los datos por orden
        const dataFromAPI = apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        setNombreUsuario(dataFromAPI[0].nombreCompleto);
    }*/

    //Marca material en planta en datosResultado
    async function marcarMaterialEnPlanta() {
        try {
            //Filtro por planeación activa
            setCargando(true);
            let filter = {
                and: [{
                    activo: {
                        eq: true
                    }
                },
                {
                    status: {
                        eq: "Aceptado"
                    }
                },
                {
                    piezasEnPlanta: {
                        attributeExists: false
                    }
                }
                ]
            }
            //Se obtienen los datos del almacén
            const apiData = await GetRecibaSeriales(filter);

            //Se ordenan los datos
            const recibaSerialesFromAPI = apiData.sort((a, b) =>
                a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0);
            var recibaSerialesPU = [];
            //Se comienza el proceso de marcar si el material está en planta
            await Promise.all(recibaSerialesFromAPI.map(async (recibaSerial, i) => {
                //Si las piezas embarcadas son menores a la cantidad recibida, se marca el material con piezas en planta
                if ((recibaSerial.piezasEmbarcadas ? recibaSerial.piezasEmbarcadas > 0 ? recibaSerial.piezasEmbarcadas : 0 : 0) <
                    (recibaSerial.cantidadRecibida ? recibaSerial.cantidadRecibida : 0)) {
                    delete recibaSerial.createdAt;
                    delete recibaSerial.updatedAt;
                    delete recibaSerial.__typename;
                    recibaSerial.Reg_Mod_Usuario = userName;
                    recibaSerial.piezasEnPlanta = true;
                    //setMensajeAlert("Se intenta guardar la reciba seriales: " + JSON.stringify(serial));
                    let resultadoc = await API.graphql({ query: updateRecibaSeriales, variables: { input: recibaSerial }, });
                    recibaSerialesPU.push(resultadoc.data.updateRecibaSeriales)
                }
                return recibaSerial;
            }))


            SetDatosResultado(recibaSerialesPU);
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert(
                "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
            );
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }
    //Marca material fuera de la planta en datosResultado
    async function marcarMaterialFueradePlanta() {
        try {
            //Filtro por planeación activa
            setCargando(true);
            let filter = {
                and: [{
                    activo: {
                        eq: true
                    }
                },
                {
                    status: {
                        eq: "Aceptado"
                    }
                },
                {
                    piezasEnPlanta: {
                        eq: true
                    }
                }
                ]
            }
            //Se obtienen los datos del almacén
            const apiData = await GetRecibaSeriales(filter);

            //Se ordenan los datos
            const recibaSerialesFromAPI = apiData.sort((a, b) =>
                a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0);
            var recibaSerialesPU = [];
            //Se comienza el proceso de marcar si el material está en planta
            await Promise.all(recibaSerialesFromAPI.map(async (recibaSerial, i) => {
                //Si las piezas embarcadas son menores a la cantidad recibida, se marca el material con piezas en planta
                if ((recibaSerial.piezasEmbarcadas ? recibaSerial.piezasEmbarcadas > 0 ? recibaSerial.piezasEmbarcadas : 0 : 0) >=
                    (recibaSerial.cantidadRecibida ? recibaSerial.cantidadRecibida : 0)) {
                    delete recibaSerial.createdAt;
                    delete recibaSerial.updatedAt;
                    delete recibaSerial.__typename;
                    recibaSerial.Reg_Mod_Usuario = userName;
                    recibaSerial.piezasEnPlanta = false;
                    //setMensajeAlert("Se intenta guardar la reciba seriales: " + JSON.stringify(serial));
                    let resultadoc = await API.graphql({ query: updateRecibaSeriales, variables: { input: recibaSerial }, });
                    recibaSerialesPU.push(resultadoc.data.updateRecibaSeriales)
                }
                return recibaSerial;
            }))


            SetDatosResultado(recibaSerialesPU);
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert(
                "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
            );
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }

    //Marca material fuera de la planta en datosResultado
    async function marcarMaterialAFueradePlanta() {
        try {
            //Filtro por planeación activa
            setCargando(true);
            let filter = {
                and: [{
                    activo: {
                        eq: true
                    }
                },
                {
                    piezasenAlmacen: {
                        eq: 0
                    }
                },
                {
                    fechaDeReciba: {
                        le: "2023-12-22"
                    }
                },
                {
                    piezasEnPlanta: {
                        eq: true
                    }
                },
                {
                    cliente: {
                        eq: "Gobar Systems Inc"
                    }
                },
                ]
            }
            /*
            {
                    piezasAEmbarcar: {
                        eq: 0
                    }
                },
                {
                    piezasenCuarentena: {
                        attributeExists: false
                    }
                },
            */
            //Se obtienen los datos del almacén
            const apiData = await GetRecibaSeriales(filter);

            //Se ordenan los datos
            const recibaSerialesFromAPI = apiData.sort((a, b) =>
                a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0);
            var recibaSerialesPU = [];
            //Se comienza el proceso de marcar si el material está en planta
            await Promise.all(recibaSerialesFromAPI.map(async (recibaSerial, i) => {
                //Si las piezas embarcadas son menores a la cantidad recibida, se marca el material con piezas en planta               
                delete recibaSerial.createdAt;
                delete recibaSerial.updatedAt;
                delete recibaSerial.__typename;
                recibaSerial.Reg_Mod_Usuario = userName;
                recibaSerial.piezasEnPlanta = false;
                //setMensajeAlert("Se intenta guardar la reciba seriales: " + JSON.stringify(serial));
                let resultadoc = await API.graphql({ query: updateRecibaSeriales, variables: { input: recibaSerial }, });
                recibaSerialesPU.push(resultadoc.data.updateRecibaSeriales)
                return recibaSerial;
            }))


            SetDatosResultado(recibaSerialesPU);
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert(
                "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
            );
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }
    //Pasar material a la tabla temporal de reciba seriales
    async function pasarMaterialEnPLantaATemporal() {
        try {
            //Filtro por material en planta
            setCargando(true);
            let filter = {
                and: [{
                    activo: {
                        eq: true
                    }
                },
                {
                    piezasEnPlanta: {
                        eq: true
                    }
                },
                ]
            }
            //Se obtienen los datos de la tabla de datosResultado
            const apiData = await GetRecibaSeriales(filter);

            //Se ordenan los datos
            const recibaSerialesFromAPI = apiData.sort((a, b) =>
                a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0);
            var recibaSerialesPU = [];
            //Se comienza el proceso de marcar si el material está en planta
            await Promise.all(recibaSerialesFromAPI.map(async (recibaSerial, i) => {
                const rsMP = { ...recibaSerial, recibaSerialID: recibaSerial.id, rsUpdatedAt: recibaSerial.updatedAt }
                delete rsMP.createdAt;
                delete rsMP.updatedAt;
                delete rsMP.__typename;
                delete rsMP.id;
                delete rsMP.recibaSerialMPID;
                //Datos recién creados.                
                setMensajeAlert(
                    "Problemas al guardar los datos de la reciba MP 1: " +
                    JSON.stringify(rsMP)
                );
                let serialesMP = await API.graphql({
                    query: createRecibaSerialesMP,
                    variables: { input: rsMP },
                });
                setMensajeAlert(
                    "Problemas al guardar los datos de la reciba seriales 1: " +
                    JSON.stringify(recibaSerial)
                );
                //Actualiza el id creado en reciba seriales
                delete recibaSerial.createdAt;
                delete recibaSerial.updatedAt;
                delete recibaSerial.__typename;
                recibaSerial.recibaSerialMPID = serialesMP.data.createRecibaSerialesMP.id;
                let resultadoc = await API.graphql({
                    query: updateRecibaSeriales,
                    variables: { input: recibaSerial },
                });
                var reseri = resultadoc.data.updateRecibaSeriales;
                var resSerialesMP = serialesMP.data.createRecibaSerialesMP;
                resSerialesMP.rsUpdatedAt = reseri.updatedAt;
                delete resSerialesMP.createdAt;
                delete resSerialesMP.updatedAt;
                delete resSerialesMP.__typename;
                setMensajeAlert("Se intenta actualizar recibaserialesMP: " + JSON.stringify(resSerialesMP));
                await API.graphql({ query: updateRecibaSerialesMP, variables: { input: resSerialesMP }, });
                recibaSerialesPU.push(resSerialesMP)
                return recibaSerial;
            }))


            SetDatosResultado(recibaSerialesPU);
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            /* window.scrollTo(0, 0);
             setMensajeAlert(
                 "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
             );*/
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }
    //Pasar la ubicación del material a reciba seriales
    async function pasarUbicacionaSeriales() {
        try {
            //Filtro por material en planta
            setCargando(true);
            let filter = {
                and: [{
                    activo: {
                        eq: true
                    }
                },
                {
                    piezasEnPlanta: {
                        eq: true
                    }
                },
                {
                    rubicaciones: {
                        attributeExists: false
                    }
                },
                {
                    status: {
                        eq: "Aceptado"
                    }
                }
                ]
            }
            //Se obtienen los datos de la tabla de datosResultado
            const apiData = await GetRecibaSeriales(filter);


            //Se ordenan los datos
            const recibaSerialesFromAPI = apiData.sort((a, b) =>
                a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0);
            var recibaSerialesPU = recibaSerialesFromAPI;
            //Se comienza el proceso de marcar si el material está en planta
            await Promise.all(recibaSerialesFromAPI.map(async (recibaSerial, i) => {
                //se obtienen  las ubicaciones del material en planta
                const tubicaciones = await GetUbicacion({ RecibaSerialesID: { eq: recibaSerial.id } });
                var ubicaciones = [];
                if (tubicaciones.length > 0) {
                    await Promise.all(tubicaciones.map(async (ubicacion, i) => {
                        ubicaciones.push({
                            ubicacion: ubicacion.ubicacion,
                            locacion: ubicacion.locacion,
                            cantidad: ubicacion.cantidad,
                            espacio: ubicacion.espacioOcupado,
                            comentarios: ubicacion.comentarios,
                            ubicaciondeReciba: ubicacion.ubicaciondeReciba,
                            activo: ubicacion.activo,
                            orden: ubicacion.orden,
                            fechaIngreso: ubicacion.fechaIngreso,
                            horaIngreso: ubicacion.horaIngreso,
                            ultimo: ubicacion.ultimo,
                            ultimoAnterior: ubicacion.ultimoAnterior,
                            fechaSalida: ubicacion.fechaSalida ? ubicacion.fechaSalida : "",
                            horaSalida: ubicacion.horaSalida ? ubicacion.horaSalida : ""
                        })
                    }))

                    delete recibaSerial.createdAt;
                    delete recibaSerial.updatedAt;
                    delete recibaSerial.__typename;
                    recibaSerial.rubicaciones = ubicaciones;
                    //Datos recién creados.                
                    setMensajeAlert(
                        "Problemas al guardar la ubicación: " + i +
                        JSON.stringify(recibaSerial)
                    );
                    //setMensajeAlert("Se intenta guardar la reciba seriales: " + JSON.stringify(serial));
                    let resultadoc = await API.graphql({ query: updateRecibaSeriales, variables: { input: recibaSerial }, });
                    recibaSerialesPU.push(resultadoc.data.updateRecibaSeriales)
                }
                return recibaSerial;
            }))


            SetDatosResultado(recibaSerialesPU);
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            /* window.scrollTo(0, 0);
             setMensajeAlert(
                 "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
             );*/
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }

    //Registrar serialesID en Reciba 
    async function registrarSerialesID() {
        try {
            //Filtro por material en planta
            setCargando(true);
            //Se obtienen los datos de la tabla de datosResultado
            let filterS = {
                and: [{
                    serialesID: {
                        attributeExists: false
                    }
                },
                {
                    fechaDeReciba: {
                        ge: "2021-01-01"
                    }
                },
                {
                    fechaDeReciba: {
                        le: "2021-12-31"
                    }
                },
                {
                    activo: {
                        eq: true,
                    }
                },]
            };
            //{ numero: { eq: "R1996" } }
            const apiData = await GetReciba({ and: [{ activo: { eq: true } }, { serialesID: { attributeExists: false } }] });
            //Se ordenan los datos
            setMensajeAlert(
                "Datos obtenidos "
            );
            const recibaFromAPI = apiData.sort((a, b) =>
                a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0);
            var recibaSerialesPU = [];
            //Se comienza el proceso de registrar serialesID en Reciba
            await Promise.all(recibaFromAPI.map(async (reciba, i) => {
                //se obtienen  las recibasSeriales
                let filter = {
                    and: [
                        {
                            recibaID: {
                                eq: reciba.id,
                            }
                        },
                        {
                            activo: {
                                eq: true,
                            }
                        },
                        {
                            activo: {
                                eq: true,
                            }
                        },
                    ]
                };
                const seriales = await GetRecibaSeriales(filter);
                var serialesID = [];
                if (seriales.length > 0) {
                    await Promise.all(seriales.map(async (serial) => {
                        serialesID.push({
                            id: serial.id
                        })
                    }))
                    if (serialesID.length > 0) {
                        delete reciba.createdAt;
                        delete reciba.updatedAt;
                        delete reciba.__typename;
                        reciba.serialesID = serialesID;
                        //Datos recién creados.                
                        setMensajeAlert(
                            "Problemas al actualizar serialesID: " + i +
                            JSON.stringify(reciba)
                        );
                        //setMensajeAlert("Se intenta guardar la reciba seriales: " + JSON.stringify(serial));
                        let resultadoc = await API.graphql({ query: updateReciba, variables: { input: reciba }, });
                        recibaSerialesPU.push(resultadoc.data.updateReciba);
                    }
                }
                return reciba;
            }))


            SetDatosResultado(recibaSerialesPU);
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            /* window.scrollTo(0, 0);
             setMensajeAlert(
                 "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
             );*/
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }

    //Registrar planeaciones generales
    async function registrarPlaneacionGeneral() {
        try {
            //Filtro por material en planta
            setCargando(true);
            //Se obtienen los datos de las planeaciones
            //{ numero: { eq: "R1996" } }
            var fechaSiguiente = "";
            var fechaActual = ""
            var fechas = [];
            var ids = [];
            var pgp = [];
            const apiData = await GetPlaneacion({ activo: { eq: true, } });
            //Se ordenan los datos
            setMensajeAlert(
                "Datos obtenidos " + JSON.stringify(apiData)
            );
            //Se ordenan los datos por fecha de reciba
            const planeacionFromAPI = apiData.sort((a, b) =>
                a.fechaDePlaneacion > b.fechaDePlaneacion ? 1 : a.fechaDePlaneacion < b.fechaDePlaneacion ? -1 : 0);
            //Se comienza el proceso de registrar serialesID en Reciba
            fechaActual = planeacionFromAPI[0].fechaDePlaneacion;
            setMensajeAlert(
                "Datos obtenidos 2" + fechaActual
            );
            await Promise.all(planeacionFromAPI.map(async (planeacion, i) => {
                //se revisa si las fechas son las mismas
                fechaSiguiente = planeacion.fechaDePlaneacion;
                if (fechaActual != fechaSiguiente || i === (planeacionFromAPI.length - 1)) {
                    if (i === (planeacionFromAPI.length - 1)) {
                        ids.push({ id: planeacion.id });
                    }
                    fechas.push({
                        fechaDePlaneacion: fechaActual,
                        PlaneacionIDS: JSON.stringify(ids),
                        numero: planeacionFromAPI[i - 1].numero,
                        activo: true,
                        Reg_Ins_Usuario: userName
                    })

                    pgp.push({
                        fechaDePlaneacion: fechaActual,
                        PlaneacionIDS: ids,
                        numero: planeacionFromAPI[i - 1].numero,
                        activo: true,
                        Reg_Ins_Usuario: userName
                    });
                    ids = [];
                    if (planeacion.id) {
                        ids.push({ id: planeacion.id });
                    }
                    fechaActual = fechaSiguiente;
                } else {
                    if (planeacion.id) {
                        ids.push({ id: planeacion.id });
                    }
                }

                return planeacion;
            }))
            await Promise.all(pgp.map(async (planeacion, i) => {
                await API.graphql({
                    query: createPlaneacionGeneral,
                    variables: { input: planeacion },
                });
                return planeacion;
            }))


            SetDatosResultado(fechas);
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            /* window.scrollTo(0, 0);
             setMensajeAlert(
                 "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
             );*/
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }

    //Registrar embarques generales
    async function registrarEmbarquesGeneral() {
        try {
            //Filtro por material en planta
            setCargando(true);

            //Se obtienen los datos de los embarques
            //{ numero: { eq: "R1996" } }
            var numeroSiguiente = "";
            var numeroActual = ""
            var fechas = [];
            var ids = [];
            var pgp = [];
            setMensajeAlert(
                "Antes de todo"
            );
            const embarqueG = await GetEmbarques({ and: [{ activo: { eq: true } }, { fechaDeEmbarque: { le: "2024-07-10" } }] });
            const apiData = await GetEmbarquesSeriales({ and: [{ activo: { eq: true } }, { fechaDeEmbarque: { le: "2024-07-10" } }] });
            //Se ordenan los datos
            setMensajeAlert(
                "Datos obtenidos " + JSON.stringify(apiData)
            );
            //Se ordenan los datos por fecha de embarque
            const embarqueFromAPI = apiData.sort((a, b) =>
                a.numero > b.numero ? 1 : a.numero < b.numero ? -1 : 0);
            //Se comienza el proceso de registrar 
            numeroActual = embarqueFromAPI[0].numero;
            setMensajeAlert(
                "Datos obtenidos 2" + numeroActual
            );
            await Promise.all(embarqueFromAPI.map(async (embarque, i) => {
                //se revisa si las fechas son las mismas
                numeroSiguiente = embarque.numero;
                const index = (i - 1) > 0 ? (i - 1) : 0;
                if (numeroActual != numeroSiguiente || i === (embarqueFromAPI.length - 1)) {
                    if (i === (embarqueFromAPI.length - 1)) {
                        ids.push({ id: embarque.id });
                    }
                    fechas.push({
                        fechaDePlaneacion: embarqueFromAPI[index].fechaDeEmbarque,
                        PlaneacionIDS: JSON.stringify(ids),
                        numero: numeroActual,
                        activo: true,
                        Reg_Ins_Usuario: userName
                    })

                    pgp.push({
                        fechaDeEmbarque: embarqueFromAPI[index].fechaDeEmbarque,
                        serialesEID: ids,
                        numero: numeroActual,
                        activo: true,
                        Reg_Ins_Usuario: userName
                    });
                    ids = [];
                    if (embarque.id) {
                        ids.push({ id: embarque.id });
                    }
                    numeroActual = numeroSiguiente;
                } else {
                    if (embarque.id) {
                        ids.push({ id: embarque.id });
                    }
                }

                return embarque;
            }))
            await Promise.all(pgp.map(async (embarque, i) => {
                const fembarque = embarqueG.filter(emb => emb.numero === embarque.numero);
                if (fembarque.length > 0) {
                    const dembarqueg = fembarque[0];
                    //if (!dembarqueg.serialesEID) {
                    setMensajeAlert("Problemas al actualizar los seriales de embarques ");
                    const rembarque = { ...dembarqueg, serialesEID: embarque.serialesEID, Reg_Mod_Usuario: userName };
                    delete rembarque.createdAt;
                    delete rembarque.updatedAt;
                    delete rembarque.__typename;
                    setMensajeAlert("Problemas al actualizar el plan de producción general 2 " + JSON.stringify(rembarque));
                    await API.graphql({ query: updateEmbarque, variables: { input: rembarque } });
                    //}

                }

                return embarque;
            }))


            SetDatosResultado(fechas);
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            /* window.scrollTo(0, 0);
             setMensajeAlert(
                 "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
             );*/
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }
    //Marca los registros de embarques como facturados
    async function registrarEmbarquesFacturados() {
        try {

            setCargando(true);
            //Se obtienen los datos de los embarques                      
            var fechas = [];
            setMensajeAlert(
                "Antes de todo"
            );
            //const embarqueG = await GetEmbarques({ and: [{ activo: { eq: true } },] });
            const apiData = await GetEmbarquesSeriales({ and: [{ activo: { eq: true } }, { facturado: { attributeExists: false } }] });
            //Se ordenan los datos
            setMensajeAlert(
                "Datos obtenidos " + JSON.stringify(apiData)
            );
            /*await Promise.all(embarqueG.map(async (embarque, i) => {
                //Se intenta hacer el cambio en embarques           
                fechas.push(embarque);
                embarque.facturado = true;
                delete embarque.createdAt;
                delete embarque.updatedAt;
                delete embarque.__typename;
                setMensajeAlert("Problemas al actualizar el plan de producción general 2 " + JSON.stringify(embarque));
                await API.graphql({ query: updateEmbarque, variables: { input: embarque } });

                return embarque;
            }))*/
            await Promise.all(apiData.map(async (embarque, i) => {
                //Se intenta hacer el cambio en embarque seriales   
                fechas.push(embarque);
                embarque.facturado = true;
                delete embarque.createdAt;
                delete embarque.updatedAt;
                delete embarque.__typename;
                setMensajeAlert("Problemas al actualizar el plan de producción general 2 " + JSON.stringify(embarque));
                await API.graphql({ query: updateEmbarqueSeriales, variables: { input: embarque } });
                return embarque;
            }))


            SetDatosResultado(fechas);
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            /* window.scrollTo(0, 0);
             setMensajeAlert(
                 "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
             );*/
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }
    //Registrar plan producción generales
    async function registrarPProduccionGeneral() {
        try {
            //Filtro por material en planta
            setCargando(true);
            //Se obtienen los datos de las planeaciones
            //{ numero: { eq: "R1996" } }
            var fechaSiguiente = "";
            var fechaActual = ""
            var fechas = [];
            var ids = [];
            var ppGC = [];
            const apiData = await GetPProduccion({ activo: { eq: true, } });
            //Se obtienen los datos del plan de producción general
            const pproducciong = await GetPProduccionGeneral({ activo: { eq: true } });
            //Se ordenan los datos
            setMensajeAlert(
                "Datos obtenidos " + JSON.stringify(apiData)
            );
            //Se ordenan los datos por fecha de reciba
            const planeacionFromAPI = apiData.sort((a, b) =>
                a.fechaDePlaneacion > b.fechaDePlaneacion ? 1 : a.fechaDePlaneacion < b.fechaDePlaneacion ? -1 : 0);
            //Se comienza el proceso de obtención de datos
            fechaActual = planeacionFromAPI[0].fechaDePlaneacion;
            setMensajeAlert("Datos obtenidos 2: " + fechaActual);
            await Promise.all(planeacionFromAPI.map(async (pproduccion, i) => {
                //se revisa si las fechas son las mismas
                fechaSiguiente = pproduccion.fechaDePlaneacion;
                setMensajeAlert("Datos obtenidos 3");
                if (fechaActual != fechaSiguiente || i === planeacionFromAPI.length - 1) {
                    if (i === (planeacionFromAPI.length - 1)) {
                        ids.push({ id: pproduccion.id });
                    }
                    fechas.push({
                        fechaDePlaneacion: fechaActual,
                        PlaneacionIDS: JSON.stringify(ids),
                        numero: planeacionFromAPI[i - 1].numero,
                        activo: true,
                        Reg_Ins_Usuario: userName
                    });
                    ppGC.push({
                        fechaDePlaneacion: fechaActual,
                        PProduccionIDS: ids,
                        numero: planeacionFromAPI[i - 1].numero,
                        espacioVacio: 0,
                        activo: true,
                        Reg_Ins_Usuario: userName
                    });
                    ids = [];
                    if (pproduccion.id) {
                        ids.push({ id: pproduccion.id });
                    }
                    fechaActual = fechaSiguiente;
                } else {
                    if (pproduccion.id) {
                        ids.push({ id: pproduccion.id });
                    }
                }
                return pproduccion;
            }));
            //Se crean o actualizan los datos en la tabla PProduccionGeneral según corresponda            
            await Promise.all(ppGC.map(async (pproduccion, i) => {
                //se revisa si las fechas son las mismas               
                setMensajeAlert("Problemas al actualizar el plan de producción general 3 " + JSON.stringify(pproduccion));
                const fpproducciong = pproducciong.filter(producciong => producciong.numero === pproduccion.numero && producciong.fechaDePlaneacion === pproduccion.fechaDePlaneacion);
                if (fpproducciong.length > 0) {
                    const dpproducciong = fpproducciong[0];
                    if (!dpproducciong.PProduccionIDS) {
                        setMensajeAlert("Problemas al actualizar el plan de producción general 7 ");
                        const rPProduccion = { ...dpproducciong, PProduccionIDS: pproduccion.PProduccionIDS, Reg_Mod_Usuario: userName };
                        delete rPProduccion.createdAt;
                        delete rPProduccion.updatedAt;
                        delete rPProduccion.__typename;
                        setMensajeAlert("Problemas al actualizar el plan de producción general 2 " + JSON.stringify(rPProduccion));
                        await API.graphql({ query: updatePProduccionGeneral, variables: { input: rPProduccion } });
                    }

                } else {
                    await API.graphql({
                        query: createPProduccionGeneral,
                        variables: { input: pproduccion },
                    });
                }
                return pproduccion;
            }))
            SetDatosResultado(fechas);
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            /* window.scrollTo(0, 0);
             setMensajeAlert(
                 "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
             );*/
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }


    //Registrar planeación y plan de Producción general
    async function actualizarPPPGeneral() {
        try {
            //Filtro por material en planta
            const fecha = Moment(new Date).format("YYYY-MM-DD");//"2024-07-15"
            setCargando(true);
            const result = await actualizarPPPGeneralM(fecha, userName);
            SetDatosResultado(result.registros);
            setMensajeAlert(result.mensaje);
            setColor(result.color);
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            /* window.scrollTo(0, 0);
             setMensajeAlert(
                 "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
             );*/
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }
    //Registrar planeación y plan de Producción general
    async function registrarDatosROperacion() {
        try {
            //Filtro por material en planta
            const fecha = Moment(new Date).format("YYYY-MM-DD");//"2024-07-15"
            setCargando(true);
            let resulppg = await API.graphql({
                query: createADatosROperacion, variables: {
                    input: {
                        ecCapacidadLinea: 200,
                        objetivoFacturacion: 15000,
                        metaVentaCumplimientoKPI: 12500,
                        activo: true,
                        Reg_Ins_Usuario: userName
                    }
                }
            });
            //SetDatosResultado(resulppg.data.createADatosROperacion);
            setMensajeAlert("Operación exitosa");
            setColor("info");
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            /* window.scrollTo(0, 0);
             setMensajeAlert(
                 "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
             );*/
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }

    //Registrar PowderCoat a Reciba
    async function registrarPowderReciba(recibaID) {
        try {
            setCargando(true);
            let filter = {
                and: [{
                    activo: {
                        eq: true
                    }
                },
                {
                    numero: {
                        eq: recibaID
                    }
                }
                ]
            }
            //Se obtienen los datos del almacén
            const apiData = await GetRecibaSeriales(filter);

            //Se ordenan los datos
            const recibaSerialesFromAPI = apiData.sort((a, b) =>
                a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0);
            var recibaSerialesPU = [];
            //Se comienza el proceso de registrar el precio unitario
            await Promise.all(recibaSerialesFromAPI.map(async (recibaSerial, i) => {
                //Se obtiene el precio unitario
                const producto = await GetProductosID(recibaSerial.productoID)
                //Si se obtuvieron los datos del producto, se procede a hacer la actualización.
                if (producto.id) {
                    delete recibaSerial.createdAt;
                    delete recibaSerial.updatedAt;
                    delete recibaSerial.__typename;
                    recibaSerial.Reg_Mod_Usuario = userName;
                    recibaSerial.precioUnitarioPC = producto.precioUnitarioPC;
                    recibaSerial.Pcoat = producto.Pcoat;
                    recibaSerial.divisa = producto.divisa;
                    //setMensajeAlert("Se intenta guardar la reciba seriales: " + JSON.stringify(serial));
                    let resultadoc = await API.graphql({ query: updateRecibaSeriales, variables: { input: recibaSerial }, });
                    recibaSerialesPU.push(resultadoc.data.updateRecibaSeriales);
                    //Se actualizan los datos en recibaSerialesMP
                    const recibaSerialMPID = recibaSerial.recibaSerialMPID;
                    if (recibaSerial.recibaSerialMPID) {
                        delete recibaSerial.recibaSerialMPID;
                        setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibaSerial));
                        await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...recibaSerial, id: recibaSerialMPID, rsUpdatedAt: resultadoc.data.updateRecibaSeriales.updatedAt } }, });
                    }

                }
                return recibaSerial;
            }))


            SetDatosResultado(recibaSerialesPU);
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setCargando(false);
            setAVisible(true);

        } catch (e) {
            /* window.scrollTo(0, 0);
             setMensajeAlert(
                 "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
             );*/
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }

    //Registra los precios unitarios en datosResultado
    async function registrarPrecioUnitario() {
        //RecibaSeriales productoID
        //Planeacion productoID
        //PProduccion productoID
        try {
            //Filtro por planeación activa
            setCargando(true);
            let filter = {
                and: [{
                    activo: {
                        eq: true
                    }
                },
                {
                    piezasenAlmacen: {
                        gt: 0
                    }
                }
                ]
            }
            //Se obtienen los datos del almacén
            const apiData = await GetRecibaSeriales(filter);

            //Se ordenan los datos
            const recibaSerialesFromAPI = apiData.sort((a, b) =>
                a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0);
            var recibaSerialesPU = [];
            //Se comienza el proceso de registrar el precio unitario
            await Promise.all(recibaSerialesFromAPI.map(async (recibaSerial, i) => {
                //Se obtiene el precio unitario
                const producto = await GetProductosID(recibaSerial.productoID)
                //Si se obtuvieron los datos del producto, se procede a hacer la actualización.
                if (producto.id) {
                    delete recibaSerial.createdAt;
                    delete recibaSerial.updatedAt;
                    delete recibaSerial.__typename;
                    recibaSerial.Reg_Mod_Usuario = userName;
                    recibaSerial.precioUnitario = producto.precioUnitario;
                    recibaSerial.divisa = producto.divisa;
                    //setMensajeAlert("Se intenta guardar la reciba seriales: " + JSON.stringify(serial));
                    let resultadoc = await API.graphql({ query: updateRecibaSeriales, variables: { input: recibaSerial }, });
                    recibaSerialesPU.push(resultadoc.data.updateRecibaSeriales)
                }
                return recibaSerial;
            }))


            SetDatosResultado(recibaSerialesPU);
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert(
                "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
            );
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }

    //Registra los precios unitarios en la planeación
    async function registrarPrecioUnitarioPlaneacion() {
        //Fechas de la planeación
        const fechainicial = Moment("2023-01-01").format("YYYY-MM-DD");
        const fechafinal = Moment("2023-01-31").format("YYYY-MM-DD");
        try {
            //Filtro por planeación activa
            setCargando(true);
            let filter = {
                and: [{
                    activo: {
                        eq: true
                    }
                },
                {
                    fechaDePlaneacion: {
                        ge: fechainicial
                    }
                },
                {
                    fechaDePlaneacion: {
                        le: fechafinal
                    }
                }]
            }
            //Se obtienen los datos de las plaenaciones
            const apiData = await GetPlaneacion(filter);

            //Se ordenan los datos
            const dataFromAPI = apiData.sort((a, b) =>
                a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0);
            var dataPU = [];
            //Se comienza el proceso de registrar el precio unitario
            await Promise.all(dataFromAPI.map(async (data, i) => {
                //Se obtiene el precio unitario
                const producto = await GetProductosID(data.productoID)
                //Si se obtuvieron los datos del producto, se procede a hacer la actualización.
                if (producto.id) {
                    delete data.createdAt;
                    delete data.updatedAt;
                    delete data.__typename;
                    data.Reg_Mod_Usuario = userName;
                    data.precioUnitario = producto.precioUnitario;
                    data.divisa = producto.divisa;
                    //setMensajeAlert("Se intenta guardar la reciba seriales: " + JSON.stringify(serial));
                    let resultadoc = await API.graphql({ query: updatePlaneacion, variables: { input: data }, });
                    dataPU.push(resultadoc.data.updatePlaneacion)
                }
                return data;
            }))


            SetDatosResultado(dataPU);
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert(
                "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
            );
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }
    //Registra los precios unitarios en la planeación
    async function registrarPrecioUnitarioPlanProduccion() {
        //Fechas de la planeación
        const fechainicial = Moment("2023-04-03").format("YYYY-MM-DD");
        const fechafinal = Moment("2023-04-20").format("YYYY-MM-DD");
        try {
            //Filtro por planeación activa
            setCargando(true);
            let filter = {
                and: [{
                    activo: {
                        eq: true
                    }
                },
                {
                    fechaDePlaneacion: {
                        ge: fechainicial
                    }
                },
                {
                    fechaDePlaneacion: {
                        le: fechafinal
                    }
                }]
            }
            //Se obtienen los datos de las plaenaciones
            const apiData = await GetPProduccion(filter);

            //Se ordenan los datos
            const dataFromAPI = apiData.sort((a, b) =>
                a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0);
            var dataPU = [];
            //Se comienza el proceso de registrar el precio unitario
            await Promise.all(dataFromAPI.map(async (data, i) => {
                //Se obtiene el precio unitario
                const producto = await GetProductosID(data.productoID)
                //Si se obtuvieron los datos del producto, se procede a hacer la actualización.
                if (producto.id) {
                    delete data.createdAt;
                    delete data.updatedAt;
                    delete data.__typename;
                    data.Reg_Mod_Usuario = userName;
                    data.precioUnitario = producto.precioUnitario;
                    data.divisa = producto.divisa;
                    //setMensajeAlert("Se intenta guardar la reciba seriales: " + JSON.stringify(serial));
                    let resultadoc = await API.graphql({ query: updatePProduccion, variables: { input: data }, });
                    dataPU.push(resultadoc.data.updatePProduccion)
                }
                return data;
            }))


            SetDatosResultado(dataPU);
            setMensajeAlert("Operación exitosa");
            setColor("primary");
            setCargando(false);
            setAVisible(true);
        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert(
                "No fue posible realizar la operación: posibles problemas de red, si el error persiste favor de comunicarse a sistemas"
            );
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    }

    return (
        <>
            {ppproduccion === true && (
                <>
                    <Fragment>

                        <Row>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" >
                                <h5 className=" floatleft">Herramientas de desarrollador</h5>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" >

                                <button className="cbutton  floatright  ml-2 btn-warning mb-3" title="Indicar como Powder a una cierta reciba" onClick={() => { registrarPowderReciba("R7009"); }}>Agregar Procesos Powder Coat Reciba R7009</button>
                                {/*
                                <button className="cbutton  floatright  ml-2 btn-warning mb-3" title="Agregar datos default de Resumen de Operacion" onClick={() => { registrarDatosROperacion(); }}>Agregar datos default de Resumen de Operacion</button>
                                <button className="cbutton  floatright  ml-2 btn-warning mb-3" title="Actualizar Planeación y Producción General" onClick={() => { actualizarPPPGeneral(); }}>Actualizar Planeación y Producción General</button>   
                                <button className="cbutton  floatright  ml-2 btn-warning mb-3" title="Registrar seriales de Embarques general" onClick={() => { registrarEmbarquesGeneral(); }}>Registrar seriales de Embarques</button>
                                <button className="cbutton  floatright  ml-2 btn-warning mb-3" title="Marcar embarques como facturados" onClick={() => { registrarEmbarquesFacturados(); }}>Marcar embarques como facturados</button>
                                <button className="cbutton  floatright  ml-2 btn-warning mb-3" title="Registrar las planeación general" onClick={() => { registrarPlaneacionGeneral(); }}>Registrar Planeación General</button>                                                                                                                                                                                            
                                <button className="cbutton  floatright  ml-2 btn-warning mb-3" title="Registrar las plan de producción general" onClick={() => { registrarPProduccionGeneral(); }}>Registrar plan de producción General</button>
                                <button className="cbutton  floatright  ml-2 btn-warning mb-3" title="Registrar Ids de seriales en Reciba" onClick={() => { registrarSerialesID(); }}>Registrar Ids de seriales en Reciba</button>
                                <button className="cbutton  floatright  ml-2 btn-warning mb-3" title="Pasar material en planta a tabla temporal" onClick={() => { pasarMaterialEnPLantaATemporal(); }}>Pasar material en planta a tabla temporal</button>
                                <button className="cbutton  floatright  ml-2 btn-warning mb-3" title="Pasar la ubicación del marerial a la tabla de seriales" onClick={() => { pasarUbicacionaSeriales(); }}>Pasar ubicación de material a seriales</button>
                               <button className="cbutton  floatright  ml-2 btn-warning mb-3" title="Marcar material atrasado fuera de planta" onClick={() => { marcarMaterialAFueradePlanta(); }}>Marcar material atrasado fuera de planta</button>
                                <button className="cbutton  floatright  ml-2 btn-warning mb-3" title="Marcar material fuera de planta<" onClick={() => { marcarMaterialFueradePlanta(); }}>Marcar material fuera de planta</button>
                                <button className="cbutton  floatright  ml-2 btn-warning mb-3" title="Marcar material en planta" onClick={() => { marcarMaterialEnPlanta(); }}>Marcar material en planta</button>
                                <button className="cbutton  floatright  ml-2 btn-info mb-3" title="Registrar precio unitario Planeación" onClick={() => { registrarPrecioUnitarioPlaneacion(); }}>Registrar precio unitario Planeación</button>
                                <button className="cbutton  floatright  ml-2 btn-warning mb-3" title="Registrar precio unitario Plan Producción" onClick={() => { registrarPrecioUnitarioPlanProduccion(); }}>Registrar precio unitario Plan Producción</button>
            <button className="cbutton  floatright  ml-2 btn-primary" title="Registrar precio unitario RecibaSeriales" onClick={() => { registrarPrecioUnitario(); }}>Registrar precio unitario RecibaSeriales</button>*/}
                            </div>
                            <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12 margintop20px">
                            </div>
                        </Row>
                        <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                                    {mensajeAlert}
                                </Alert>
                            </div>
                            {cargando === true && (
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                    <img width="150px" src="assets/img/preloader.gif" />
                                </div>
                            )}
                        </Row>
                        <Row>
                            <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                                {/*<Table className="mb-2 scroll ">
                                    <Thead class="thead-secondary">
                                        <Tr>
                                            <Th className="minwidth80px">No.</Th>
                                            <Th className="minwidth80px">ID</Th>
                                            <Th>Cliente</Th>
                                            <Th className="minwidth80px">
                                                Fecha y hora de reciba
                                            </Th>
                                            <Th>Estatus </Th>
                                            <Th>Packing </Th>
                                            <Th>Número de parte</Th>
                                            <Th>Lote</Th>
                                            <Th className="minwidth100px">Serial </Th>
                                            <Th className="minwidth100px">Serial BTI </Th>
                                            <Th>Precio Unitario</Th>
                                            <Th>Divisa</Th>
                                            <Th className="width30px"> En planta </Th>
                                            <Th className="width30px"> Última ubicación </Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {datosResultado.map((recibas, i) => (
                                            <Tr className={i % 2 !== 0 ? "table-active" : ""}>
                                                <Td>{i + 1}</Td>
                                                <Td>{recibas.numero}</Td>
                                                <Td>{recibas.cliente}</Td>
                                                <Td className="margintopmobil20px">
                                                    {recibas.fechayHoraDeReciba}
                                                </Td>
                                                <Td className="margintopmobil20px">
                                                    {recibas.status}
                                                </Td>
                                                <Td className="margintopmobil20px">
                                                    {recibas.packing}
                                                </Td>
                                                <Td className="margintopmobil20px">
                                                    {recibas.numerodeParte}
                                                </Td>
                                                <Td className="margintopmobil20px">
                                                    {recibas.lote}
                                                </Td>
                                                <Td className="margintopmobil20px">
                                                    {recibas.serial}
                                                </Td>
                                                <Td className="margintopmobil20px">
                                                    {recibas.serialRecibaBTI}
                                                </Td>
                                                <Td className="margintopmobil20px">
                                                    {recibas.precioUnitario}
                                                </Td>
                                                <Td className="margintopmobil20px">
                                                    {recibas.divisa}
                                                </Td>
                                                <Td className="margintopmobil40px">
                                                    {recibas.piezasEnPlanta ? "Sí" : "No"}
                                                </Td>
                                                <Td className="margintopmobil20px">
                                                    {recibas.ultimaUbicacion}
                                                </Td>
                                            </Tr>
                                        ))}
                                    </Tbody>
                                </Table>*/}
                                <Table className="mb-2 scroll ">
                                    <Thead class="thead-secondary">
                                        <Tr>
                                            <Th className="minwidth80px">No.</Th>
                                            <Th className="minwidth80px">fecha</Th>
                                            <Th>Numero</Th>
                                            <Th className="minwidth80px">
                                                Activo
                                            </Th>
                                            <Th>Ids </Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {datosResultado.map((fechas, i) => (
                                            <Tr className={i % 2 !== 0 ? "table-active" : ""}>
                                                <Td>{i + 1}</Td>
                                                <Td>{fechas.fechaDePlaneacion}</Td>
                                                <Td className="margintopmobil20px">
                                                    {fechas.numero}
                                                </Td>
                                                <Td>{fechas.activo}</Td>
                                                <Td className="margintopmobil20px">
                                                    {fechas.PlaneacionIDS}
                                                </Td>
                                            </Tr>
                                        ))}
                                    </Tbody>
                                </Table>
                            </div>
                        </Row>
                    </Fragment>

                </>
            )}
        </>
    )
};



export default Tools;
